/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrivateBankingServiceDefinitionId } from './PrivateBankingServiceDefinitionId';
import {
    PrivateBankingServiceDefinitionIdFromJSON,
    PrivateBankingServiceDefinitionIdFromJSONTyped,
    PrivateBankingServiceDefinitionIdToJSON,
    PrivateBankingServiceDefinitionIdToJSONTyped,
} from './PrivateBankingServiceDefinitionId';

/**
 * One set of products that together block the product owning this entry. Conflicts are directional, so a mutual exclusion is expressed as one entry on each of the two products.
 * @export
 * @interface ProductConflict
 */
export interface ProductConflict {
    /**
     * The products that together cause this conflict. It applies only when the business relation has all of them, so Periodic Mail Dispatch conflicts with E-Banking and E-Documents together rather than with E-Banking alone.
     * @type {Array<PrivateBankingServiceDefinitionId>}
     * @memberof ProductConflict
     */
    conflictingProductIds?: Array<PrivateBankingServiceDefinitionId>;
    /**
     * The warning to show when this conflict applies, already composed. Rendered by the backend because it names products the client cannot always resolve, such as Hold Mail, which is excluded from the catalogue.
     * @type {string}
     * @memberof ProductConflict
     */
    message?: string;
}

/**
 * Check if a given object implements the ProductConflict interface.
 */
export function instanceOfProductConflict(value: object): value is ProductConflict {
    return true;
}

export function ProductConflictFromJSON(json: any): ProductConflict {
    return ProductConflictFromJSONTyped(json, false);
}

export function ProductConflictFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductConflict {
    if (json == null) {
        return json;
    }
    return {
        
        'conflictingProductIds': json['conflictingProductIds'] == null ? undefined : ((json['conflictingProductIds'] as Array<any>).map(PrivateBankingServiceDefinitionIdFromJSON)),
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ProductConflictToJSON(json: any): ProductConflict {
    return ProductConflictToJSONTyped(json, false);
}

export function ProductConflictToJSONTyped(value?: ProductConflict | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conflictingProductIds': value['conflictingProductIds'] == null ? undefined : ((value['conflictingProductIds'] as Array<any>).map(PrivateBankingServiceDefinitionIdToJSON)),
        'message': value['message'],
    };
}

